import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import Icon from '@material-ui/icons/Repeat';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToRecert = ({ classes, record }) => (
    (record.recert_id)? 
        <Button
            size="small"
            color="primary"
            component={Link}
            to={{
                pathname: '/recertificate',
                search: stringify({
                    page: 1,
                    perPage: 25,
                    sort: 'id',
                    order: 'DESC',
                    filter: JSON.stringify({ uid: record.id}),
                }),
                uid: record.id
            }}
            className={classes.link}
        >
            <Icon className={classes.icon}  />
        </Button> 
    :  <Button
            size="small"
            color="primary"
            component={Link}
            disabled
        >
            <Icon className={classes.icon}  />
        </Button> 
);

export default withStyles(styles)(LinkToRecert);
